import { render, staticRenderFns } from "./TravelerTypeForm.vue?vue&type=template&id=06adae82&"
import script from "./TravelerTypeForm.vue?vue&type=script&lang=js&"
export * from "./TravelerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports